import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
//import DialogTitle from '@mui/material/DialogTitle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
//import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';
//import StepProgressBar from './StepProgressBar';


interface ProfileDialogTitleProps {
    onBack: () => void;
    onClose: () => void;
    children: React.ReactNode;
    subtitle?: string | null;
    color?: string
    stepIndex: number
    noBackArrow?: boolean
}

export const ProfileDialogTitle: React.FC<ProfileDialogTitleProps> = ({ onBack, onClose, children, subtitle, color, stepIndex, noBackArrow}) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', color:color, width: '100%' }}>
            {/* Spacer to balance the close button */}
            <Box sx={{ width: 32 }} />
            <Box sx={{ flexGrow: 1, textAlign: 'center' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.2, fontSize: '1rem' }}>
                    {children}
                </Typography>
                {subtitle && (
                    <Typography variant="caption" sx={{ color: '#656EFF', fontWeight: 600, mt: 0.25, display: 'block' }}>
                        {subtitle}
                    </Typography>
                )}
            </Box>
            <IconButton
                onClick={onClose}
                aria-label="close"
                size="small"
                sx={{
                    width: 32,
                    height: 32,
                    backgroundColor: 'rgba(0,0,0,0.04)',
                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.08)' },
                }}
            >
                <CloseIcon sx={{ fontSize: 16, color: '#666' }} />
            </IconButton>
        </Box>
    );
}

